// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__c8f0J","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3lWqU"};